import { render, staticRenderFns } from "./TransactionCancelled.vue?vue&type=template&id=447f06f2"
import script from "./TransactionCancelled.vue?vue&type=script&lang=js"
export * from "./TransactionCancelled.vue?vue&type=script&lang=js"
import style0 from "./TransactionCancelled.vue?vue&type=style&index=0&id=447f06f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports